module.exports = __webpack_public_path__ + "img/Flunder_8.5310eeaf.jpg";